module.exports = __webpack_public_path__ + "assets/img/ff304aaedcac0f6946a642e8a68e897f.webp";